/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/userLists.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_PRESENTATIONS, GET_SECTION } from "../graphql";
import { VApplication } from "../../../application";

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ISectionMethods extends IPluginMethodMap {
  getSectionProps(args: any): Promise<any>;
}

export class SectionService implements IAgentPlugin {
  readonly methods: ISectionMethods;

  constructor() {
    this.methods = {
      getSectionProps: this.getSectionProps.bind(this),
    };
  }

  async getSectionProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    const _filter = {
      year: {
        eq: "2024",
      },
      status: {
        eq: "active",
      },
    };
    try {
      if (client) {
        const _res = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: _filter,
            options: {
              limit: args?.size ?? 10,
              skip: args?.offset ?? 0,
            },
          },
          fetchPolicy: "network-only",
        });
        const defaultPresentation =
          _res?.data?.getPresentations?.content[0]?.id;
        const filter = args?.criteria?.id
          ? {
              _id: {
                eq: args?.criteria?.id,
              },
            }
          : {
              _id: {
                eq: defaultPresentation,
              },
            };
        const res = await client.query({
          query: GET_SECTION,
          variables: {
            filter: filter,
          },
          fetchPolicy: "network-only",
        });

        if (res?.data) {
          let _rowData = this.formatTable(res?.data?.getPresentations?.content);

          let _totalPages = res?.data?.getPresentations?.content?.count
            ? Math.ceil(
                parseInt(res?.data?.getPresentations?.content?.count) / 10
              )
            : 1;

          let _currentPage =
            res?.data?.getPresentations?.skip /
              res?.data?.getPresentations?.limit +
            1;

          return {
            ...config,
            ultUsers: _rowData,
            isEmpty: res?.data?.getPresentations?.content?.length <= 0,
            activePage: _currentPage,
            pageSize: res?.data?.getPresentations?.limit,
            totalCount: _rowData.length,
            totalPages: _totalPages,
            searchStatusFilter: _res?.data?.getPresentations?.content?.map(
              (_item: any) => {
                return { value: _item?.id, label: _item?.name };
              }
            ),
          };
        }
      }
    } catch (err: any) {
      console.log(`error in table data`, err);
      return {
        isEmpty: true,
      };
    }
  }
  private formatTable(costume: any[]): any {
    let _rowData: any = [];
    costume.forEach((item: any) => {
      if (item && is.existy(item) && is.not.empty(item)) {
        item.sections.forEach((section:any) => {
          if (section && is.existy(section) && is.not.empty(section)) {
            let frontline = section.costumeTypes.find((costumeType:any) =>
              costumeType.name.toUpperCase().includes("FRONTLINE")
            );
            let backline = section.costumeTypes.find((costumeType:any) =>
              costumeType.name.toUpperCase().includes("BACKLINE")
            );
            let male = section.costumeTypes.find((costumeType:any) =>
              costumeType.name.toUpperCase().includes("MALE")
            );
            _rowData.push({
              sectionName: section.name,
              frontline: frontline?.price,
              backline: backline?.price,
              male: male?.price,
            });
          }
        });
      }
    });
    return _rowData;
  }
}
